angular.module('app').factory('generalService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/general/");

        return {
            createSkin: function (requestData) {
                return restAngular.
                    one("createCms").
                    post("", requestData)
            },
            getAllLanguages: function () {
                return restAngular.
                    one("getAllLanguages").
                    get()
            },
            editSkin: function (requestData) {
                return restAngular.
                    one("changeCms").
                    post("", requestData)
            }
        }
    }
]);